<template>
    <div>
        <dx-grid
            url="purimStudents"
            :baseUrl="getDomain()"
            :columns="columns"
            :title="title"
            :selectionEnabled="true"
            :actions="actions"
            navigationPath="PurimStudentView"
            navigationField="studentID"
            ref="grid"
            :summaryOptions="{
                enabled: true,
                columns: [
                    'paid',
                    'totalMissingAmount',
                    'bonus',
                    'totalPaid',
                    'paidGroup',
                    'amountUnconfirmed',
                    'trackAmount',
                    'earn',
                    'beforePurimAmount',
                    'track9',
                ],
            }"
        ></dx-grid>
        <v-dialog scrollable v-model="newBulkPaymentDialog" max-width="1300">
            <new-bulk-payment
                :closeNewPaymentDialog="closeNewPaymentDialog"
                :students="selectedStudents"
                :reloadGrid="reloadGrid"
                :getDomain="getDomain"
                :setup="setup"
            ></new-bulk-payment>
        </v-dialog>
        <v-dialog scrollable v-model="newBulkGiftDialog" max-width="1200">
            <new-bulk-gift
                :closeNewGiftDialog="closeNewGiftDialog"
                :students="selectedStudents"
                :reloadGrid="reloadGrid"
                :getDomain="getDomain"
                :setup="setup"
            ></new-bulk-gift>
        </v-dialog>
        <v-dialog scrollable v-model="addTrackingDialog" max-width="800">
            <add-bulk-tracking
                :closeAddTrackingDialog="closeAddTrackingDialog"
                :students="selectedStudents"
                :reloadGrid="reloadGrid"
                :getDomain="getDomain"
                :setup="setup"
            ></add-bulk-tracking>
        </v-dialog>
        <v-dialog scrollable v-model="addHoursDialog" max-width="800">
            <add-bulk-hours
                :closeAddTrackingDialog="closeAddHoursDialog"
                :students="selectedStudents"
                :reloadGrid="reloadGrid"
                :getDomain="getDomain"
                :setup="setup"
            ></add-bulk-hours>
        </v-dialog>
    </div>
</template>

<script>
import newBulkPayment from "./PurimNewBulkPayment.vue";
import newBulkGift from "./PurimNewBulkGift.vue";
import addBulkTracking from "./PurimAddBulkTracking.vue";
import addBulkHours from "./PurimAddBulkHours.vue";
import moment from "moment";
import { toISOLocal } from "../../utils/helpers.js";

export default {
    components: {
        newBulkPayment,
        newBulkGift,
        addBulkTracking,
        addBulkHours,
    },
    data: () => ({
        title: "Students",
        columns: [
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                link: "PurimStudentView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "fullName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameE",
                field: "fullNameE",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father",
                field: "father",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "fname",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "laname",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Eng Name",
                field: "fullNameE",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "grade",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacher",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "City",
                field: "city",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "State",
                field: "state",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "ZipCode",
                field: "zipCode",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Phone",
                field: "phone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "GroupName",
                field: "groupName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Pin",
                field: "pin",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Current Year",
                field: "currentYear",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Gabba",
                field: "gabba",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Paid",
                field: "paid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Missing Amount",
                field: "totalMissingAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hours",
                field: "hours",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bonus",
                field: "bonus",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Total Paid",
                field: "totalPaid",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },

            {
                label: "Paid Group",
                field: "paidGroup",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Amount Unconfirmed",
                field: "amountUnconfirmed",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track Amount",
                field: "trackAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Earn",
                field: "earn",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notes",
                field: "notes",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Gabba",
                field: "isGabba",
                type: "boolean",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Transaction Count",
                field: "transactionCount",
                type: "number",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "H Transaction Count",
                field: "hTransactionCount",
                type: "number",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Before Purim Amount",
                field: "beforePurimAmount",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Gift Value",
                field: "giftsValue",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Active",
                field: "isActive",
                visible: true,
                filterValues: [],
                filterValue: true,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "studentNote",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track1",
                field: "track1",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track2",
                field: "track2",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track3",
                field: "track3",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track4",
                field: "track4",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track5",
                field: "track5",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track6",
                field: "track6",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track7",
                field: "track7",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track8",
                field: "track8",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Track9",
                field: "track9",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],

        setup: {},

        selectedStudents: [],
        newBulkPaymentDialog: false,
        newBulkGiftDialog: false,
        addTrackingDialog: false,
        addHoursDialog: false,
    }),
    async created() {
        this.actions.push({
            text: "Actions",
            isMenu: true,
            items: [
                {
                    value: "add-payments",
                    text: "Add Payments",
                },
                {
                    value: "add-gifts",
                    text: "Add Gifts",
                },
                {
                    value: "add-tracking",
                    text: "Add Tracking",
                },
                {
                    value: "add-hours",
                    text: "Add Hours",
                },
            ],
            value: "Actions",
            name: "Actions",
            action: this.openActionModal,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Reports",
            isMenu: true,
            items: [
                {
                    value: "allStudentsReport",
                    text: "Student List Report",
                },
                {
                    value: "detailsReport",
                    text: "Detail Report",
                },
                {
                    value: "groupReport",
                    text: "Group Report",
                },
                {
                    value: "studentCollectionReport",
                    text: "Student Collection",
                },
            ],
            value: "StudentList",
            action: this.printReport,
            showOnSelection: true,
        });

        const trackSetup = await this.getTrackSetups();

        this.columns.forEach((column) => {
            if (
                ![
                    "track1",
                    "track2",
                    "track3",
                    "track4",
                    "track5",
                    "track6",
                    "track7",
                    "track8",
                    "track9",
                ].includes(column.field)
            )
                return;

            const code = column.field.substr(-1);

            const setup = trackSetup.find((g) => g.code == code);

            column.label = setup.description;
        });

        this.loadSetup();
    },
    methods: {
        openActionModal(option) {
            switch (option) {
                case "add-payments":
                    return this.addPayments();
                case "add-gifts":
                    return this.addGifts();
                case "add-hours":
                    return this.addHours();
                case "add-tracking":
                    return this.addTracking();
            }
        },
        async getTrackSetups() {
            const trackSetups = await this.$http.get(
                this.getDomain() + "/api/setup/getTrackSetup",
            );

            return trackSetups;
        },
        async loadSetup() {
            const setup = await this.$http.get(
                this.getDomain() + "/api/setup/getSetup",
            );

            this.setup = setup;
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:50346"
                : "https://purim-admin-portal.azurewebsites.net";
        },
        async getSelectedStudents() {
            var grid = this.$refs.grid;

            const sortOptions =
                grid.dataSource.loadOptions().sort &&
                grid.dataSource.loadOptions().sort.length
                    ? grid.dataSource.loadOptions().sort[0]
                    : "";

            const selected = grid.getSelectedRowsData();

            if (sortOptions) {
                return this.sort(
                    selected,
                    sortOptions.selector,
                    sortOptions.desc,
                );
            }

            return selected;
        },
        sort(list, prop, desc) {
            return list.sort((a, b) => {
                if (desc) {
                    if (a[prop] > b[prop]) return -1;
                    if (a[prop] < b[prop]) return 1;
                } else {
                    if (a[prop] > b[prop]) return 1;
                    if (a[prop] < b[prop]) return -1;
                }

                return 0;
            });
        },
        async addPayments() {
            //const selectedStudents = this.$refs.grid.getSelectedRowsData();
            const selectedStudents = await this.getSelectedStudents();

            this.selectedStudents = JSON.parse(
                JSON.stringify(selectedStudents),
            ).map((student) => {
                student.amount = "";
                student.amountFound = "";
                student.paymentType = "Cash";
                student.note = "";
                student.confirmed = true;
                student.datePickerMenu = false;
                student.date = toISOLocal(new Date(moment())).substr(0, 10);

                return student;
            });

            this.newBulkPaymentDialog = true;
        },
        async printReport(report) {
            const data = await this.$refs.grid.getSelectedRowsData();

            const studentIDs = data.map((s) => s.studentID);

            try {
                const response = await this.$http({
                    url: this.getDomain() + "/api/reports/" + report,
                    method: "POST",
                    data: studentIDs,
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(
                    new Blob([response], { type: "application/pdf" }),
                );
                const link = document.createElement("a");
                link.href = url;
                const fileName = this.actions
                    .find((a) => a.text == "Reports")
                    .items.find((a) => a.value == report).text;
                link.setAttribute("download", fileName + ".pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.open(url, "_blank");
            } catch (e) {
                console.log(e);
            } finally {
            }

            // window.open(
            //     this.getDomain() +
            //         "/api/reports/" +
            //         report +
            //         "?filter=" +
            //         filter
            // );
        },
        closeNewPaymentDialog() {
            this.selectedStudents = [];

            this.newBulkPaymentDialog = false;
        },
        async addGifts() {
            const selectedStudents = await this.getSelectedStudents();

            this.selectedStudents = JSON.parse(
                JSON.stringify(selectedStudents),
            ).map((student) => {
                student.giftType = "";
                student.quantity = 1;
                student.orderNumber = "";
                student.note = "";
                student.pickedUp = false;

                return student;
            });

            this.newBulkGiftDialog = true;
        },
        closeNewGiftDialog() {
            this.selectedStudents = [];

            this.newBulkGiftDialog = false;
        },
        async addTracking() {
            const selectedStudents = await this.getSelectedStudents();

            this.selectedStudents = JSON.parse(
                JSON.stringify(selectedStudents),
            ).map((student) => {
                student.trackType = "";
                student.data = "";

                return student;
            });

            this.addTrackingDialog = true;
        },
        closeAddTrackingDialog() {
            this.selectedStudents = [];

            this.addTrackingDialog = false;
        },
        async addHours() {
            const selectedStudents = await this.getSelectedStudents();

            this.selectedStudents = JSON.parse(
                JSON.stringify(selectedStudents),
            ).map((student) => {
                student.groupName = "";
                student.hours = "";

                return student;
            });

            this.addHoursDialog = true;
        },
        closeAddHoursDialog() {
            this.selectedStudents = [];

            this.addHoursDialog = false;
        },
        reloadGrid() {
            this.$refs.grid.reloadGrid();
        },
    },
};
</script>
